import React, {useMemo, useState} from "react";
import {Alert, Surface, useTheme} from "tmwx-design-web/src";
import {
    MaterialReactTable,
    MRT_ColumnDef,
    MRT_Row,
    MRT_TableOptions,
    useMaterialReactTable
} from "material-react-table";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "gui-common/redux/store";
import {Variables} from "gui-common/redux/data/pythonScript";
import {useTranslation} from "react-i18next";
import {usePermissions} from "tmwx-design-common";
import Text from "tmwx-design-web/src/components/Text";
import Popup from "tmwx-design-web/src/components/Popup";
import Button from "tmwx-design-web/src/components/Button";

const VariablesTable = () => {
    const {t} = useTranslation()
    const {padding, roundness} = useTheme()
    const dispatch: any = useDispatch()
    const {hasRights} = usePermissions()
    const loading = useSelector<RootState, boolean>(state => state.pythonScript.loading);
    const variablesList = useSelector<RootState, Variables[]>(state => state.pythonScript.variablesList);
    const [validationErrors, setValidationErrors] = useState<
        Record<string, string | undefined>
    >({});
    //keep track of rows that have been edited
    const [editedVariables, setEditedVariables] = useState<Record<string, Variables>>({});

    //call CREATE hook
    // const { mutateAsync: createUser, isPending: isCreatingUser } =
    //     useCreateUser();
    // //call READ hook
    // const {
    //     data: fetchedUsers = [],
    //     isError: isLoadingUsersError,
    //     isFetching: isFetchingUsers,
    //     isLoading: isLoadingUsers,
    // } = useGetUsers();
    // //call UPDATE hook
    // const { mutateAsync: updateUsers, isPending: isUpdatingUsers } =
    //     useUpdateUsers();
    // //call DELETE hook
    // const { mutateAsync: deleteUser, isPending: isDeletingUser } =
    //     useDeleteUser();

    //CREATE action
    const handleCreateVariables: MRT_TableOptions<Variables>['onCreatingRowSave'] = async ({
                                                                                         values,
                                                                                         table,
                                                                                     }) => {
        // const newValidationErrors = validateUser(values);
        // if (Object.values(newValidationErrors).some((error) => error)) {
        //     setValidationErrors(newValidationErrors);
        //     return;
        // }
        // setValidationErrors({});
        // await createUser(values);
        // table.setCreatingRow(null); //exit creating mode
    };

    //UPDATE action
    const handleSaveVariables = async () => {
        // if (Object.values(validationErrors).some((error) => !!error)) return;
        // await updateUsers(Object.values(editedUsers));
        // setEditedUsers({});
    };

    //DELETE action
    const openDeleteConfirmModal = (row: MRT_Row<Variables>) => {
        // if (window.confirm('Are you sure you want to delete this user?')) {
        //     deleteUser(row.original.id);
        // }
    };

    const validateRequired = (value: string) => !!value.length;

    const columns = useMemo<MRT_ColumnDef<Variables>[]>(
        () => [
            {
                accessorKey: 'vagGroupName',
                header: t('efe.variablesTable.group'),
                muiEditTextFieldProps: ({ cell, row }) => ({
                    type: 'text',
                    required: true,
                    error: !!validationErrors?.[cell.id],
                    helperText: validationErrors?.[cell.id],
                    //store edited variable in state to be saved later
                    onBlur: (event) => {
                        const validationError = !validateRequired(event.currentTarget.value)
                            ? 'Required'
                            : undefined;
                        setValidationErrors({
                            ...validationErrors,
                            [cell.id]: validationError,
                        });
                        setEditedVariables({ ...editedVariables, [row.id]: row.original });
                    },
                }),
            },
            {
                accessorKey: 'varPyVariableName',
                header: t('name'),
                muiEditTextFieldProps: ({ cell, row }) => ({
                    type: 'text',
                    required: true,
                    error: !!validationErrors?.[cell.id],
                    helperText: validationErrors?.[cell.id],
                    onBlur: (event) => {
                        const validationError = !validateRequired(event.currentTarget.value)
                            ? 'Required'
                            : undefined;
                        setValidationErrors({
                            ...validationErrors,
                            [cell.id]: validationError,
                        });
                        setEditedVariables({ ...editedVariables, [row.id]: row.original });
                    },
                }),
            },
            {
                accessorKey: 'varSourceId',
                header: t('efe.variablesTable.source'),
                muiEditTextFieldProps: ({ cell, row }) => ({
                    type: 'text',
                    required: true,
                    error: !!validationErrors?.[cell.id],
                    helperText: validationErrors?.[cell.id],
                    onBlur: (event) => {
                        const validationError = !validateRequired(event.currentTarget.value)
                            ? 'Required'
                            : undefined;
                        setValidationErrors({
                            ...validationErrors,
                            [cell.id]: validationError,
                        });
                        setEditedVariables({ ...editedVariables, [row.id]: row.original });
                    },
                }),
            },
            {
                accessorKey: 'varDescription',
                header: t('efe.register.desc'),
                muiEditTextFieldProps: ({ cell,row }) => ({
                    type: 'text',
                    required: true,
                    error: !!validationErrors?.[cell.id],
                    helperText: validationErrors?.[cell.id],
                    onBlur: (event) => {
                        const validationError = !validateRequired(event.currentTarget.value)
                            ? 'Required'
                            : undefined;
                        setValidationErrors({
                            ...validationErrors,
                            [cell.id]: validationError,
                        });
                        setEditedVariables({ ...editedVariables, [row.id]: row.original });
                    },
                }),
            },
        ],
        [dispatch, hasRights, padding, t],
    );


    const table = useMaterialReactTable({
        columns,
        data: variablesList,
        createDisplayMode: 'row', // ('modal', and 'custom' are also available)
        editDisplayMode: 'table', // ('modal', 'row', 'cell', and 'custom' are also
        enableEditing: true,
        enableRowActions: false,
        positionActionsColumn: 'last',
        // getRowId: (row) => row.ptcId,
        // muiToolbarAlertBannerProps: isLoadingUsersError
        //     ? {
        //         color: 'error',
        //         children: 'Error loading data',
        //     }
        //     : undefined,
        muiTableContainerProps: {
            sx: {
                minHeight: '500px',
            },
        },
        onCreatingRowCancel: () => setValidationErrors({}),
        // onCreatingRowSave: handleCreateUser,
        renderRowActions: ({ row }) => (
            <Popup type='hover' triggerComponent={
                <Button iconLeft={"delete"} status='neutral' variant='ghost' onPress={() => openDeleteConfirmModal(row)}/>
            }>
                <Surface style={{ padding: padding }} elevation={2}>
                    <Text>{t('delete')}</Text>
                </Surface>
            </Popup>
        ),
        renderBottomToolbarCustomActions: () => (
            <Surface style={{ display: 'flex', alignItems: 'center' }}>
                <Button status="primary" onPress={handleSaveVariables}
                    disabled={
                        Object.keys(editedVariables).length === 0 ||
                        Object.values(validationErrors).some((error) => !!error)
                    }>
                    {t('save')}
                </Button>
                {Object.values(validationErrors).some((error) => !!error) && (
                    <Alert style={{marginBottom: 8}} text={t('mandatoryFields')} status="danger"/>
                )}
            </Surface>
        ),
        renderTopToolbarCustomActions: ({ table }) => (
            <Popup
                type='hover'
                triggerComponent={
                    <Button iconLeft={"add"} status='neutral' variant='ghost' onPress={() => {
                        table.setCreatingRow(true); //simplest way to open the create row modal with no default values
                        //         //or you can pass in a row object to set default values with the `createRow` helper function
                        //         // table.setCreatingRow(
                        //         //   createRow(table, {
                        //         //     //optionally pass in default values for the new row, useful for nested data or other complex scenarios
                        //         //   }),
                        //         // );
                    }} />
                }
            >
                <Surface style={{ padding: padding }} elevation={2}>
                    <Text>{t('add')}</Text>
                </Surface>
            </Popup>
        ),
        state: {
            isLoading: loading,
            showProgressBars: loading,
        },
    });

    return (
        <Surface style={{marginBottom: 4, marginLeft: 4, marginRight: 4, width: '100%'}}>
            <MaterialReactTable table={table} />
        </Surface>
    )
}

export default VariablesTable;